import React from 'react';
import { Navigation } from 'lucide-react';
export function Footer() {
  return <footer className="bg-slate-950 py-12 border-t border-slate-800" data-id="element-55">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-56">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6" data-id="element-57">
          <div className="flex items-center gap-2" data-id="element-58">
            <img src="https://cdn.weweb.io/designs/95b2d8ad-3462-4b4f-8f64-0d1b08dcdb9e/sections/Lighthouse-Logomark__3_.svg?_wwcv=1748379697899" alt="Lighthouse AI" className="w-6 h-6" data-id="element-59" />
            <span className="font-display font-bold text-lg text-white tracking-tight" data-id="element-60">
              Lighthouse AI
            </span>
          </div>

          <div className="flex items-center gap-6 text-sm text-slate-400" data-id="element-61">
            <a href="#" className="hover:text-white transition-colors" data-id="element-62">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-63">
              Terms of Service
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-64">
              Contact
            </a>
          </div>

          <div className="text-sm text-slate-500" data-id="element-65">
            © {new Date().getFullYear()} Lighthouse AI. All rights reserved.
          </div>
        </div>
      </div>
    </footer>;
}